import { comprasSections } from './comprasSections';

export const comprasManual = {
  id: 'mod-compras',
  title: 'Compras',
  isVisible: (ctx) => ctx.limitedScope.showCompras,
  intro:
    'Ciclo de abastecimiento: proveedores, requerimiento, orden de compra o servicio, recepción documental, servicios continuos y reportes de precios. Incluye «Grilla de productos e ítems — Compras»; la guía común de columnas está en Inicio y acceso. Cada función del menú está documentada con la plantilla de 12 apartados.',
  sections: comprasSections,
};
